import { Check, Copy, MessageCircle } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui';
import { copyText, whatsappShareUrl } from '@/lib/teams-text';

/**
 * "Copiar" e "Enviar no WhatsApp" para a escalação. O texto é montado por quem
 * chama (a tela de ajuste usa o rascunho, a da partida usa o salvo).
 */
export function ShareTeamsButtons({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);
  const [failed, setFailed] = useState(false);

  async function handleCopy() {
    try {
      await copyText(text);
      setFailed(false);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 2000);
    } catch {
      setFailed(true);
    }
  }

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button size="sm" variant="secondary" icon={copied ? Check : Copy} onClick={handleCopy}>
        {copied ? 'Copiado!' : 'Copiar times'}
      </Button>
      <Button
        size="sm"
        variant="secondary"
        icon={MessageCircle}
        onClick={() => window.open(whatsappShareUrl(text), '_blank', 'noopener')}
      >
        Enviar no WhatsApp
      </Button>
      {failed ? (
        <span className="text-[12px] text-bad">Não deu para copiar neste navegador.</span>
      ) : null}
    </div>
  );
}
